import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import I18n from '../i18n';
import Button from '../button';

export default function ConfirmationModal(props) {
  const {onCancel, onConfirm, children, confirmButtonText, cancelButtonText, ...rest} = props;
  return (
    <Modal dialogClassName="confirmation-modal" onHide={onCancel} centered {...rest}>
      <Modal.Body>
        <p>
          <span className="dialog-icon dialog-icon-danger fa fa-fw fa-exclamation-triangle" />
        </p>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-dark" onClick={onCancel}>
          <I18n t={cancelButtonText} />
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          <I18n t={confirmButtonText} />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ConfirmationModal.defaultProps = {
  confirmButtonText: 'action.yes',
  cancelButtonText: 'action.no',
};

ConfirmationModal.propTypes = {
  /** Callback function to execute if user clicks confirm. */
  onConfirm: PropTypes.func.isRequired,
  /** Callback function to execute if user clicks cancel. */
  onCancel: PropTypes.func.isRequired,
  /** Message to show to the user. */
  children: PropTypes.node.isRequired,
  /** Optional i18n key for the "confirm" button. Defaults to "Yes" */
  confirmButtonText: PropTypes.string,
  /** Optional i18n key for the "cancel" button. Defaults to "No" */
  cancelButtonText: PropTypes.string,
};
